import { useEffect, useMemo, useState } from "react";
import { useMutation, useQuery } from "convex/react";
import { api } from "../../../convex/_generated/api";
import ClientesSidebar from "./ClientesSidebar.tsx";
import ClienteForm from "./ClienteForm.tsx";

export default function ClientesPage() {
    const clients = useQuery(api.index.clients_list) ?? [];
    const salvar = useMutation(api.index.clients_upsert);
    const firstId =
        clients && clients.length > 0 && clients[0]?._id
            ? (clients[0]!._id as unknown as string)
            : null;
    const [selecionado, setSelecionado] = useState<string | null>(firstId);
    useEffect(() => {
        if (!selecionado && clients.length && clients[0]?._id)
            setSelecionado(clients[0]!._id as string);
    }, [clients, selecionado]);

    const [busca, setBusca] = useState("");
    const filtrados = clients.filter((c) =>
        (c.name + " " + (c.phone ?? "") + " " + (c.email ?? ""))
            .toLowerCase()
            .includes(busca.toLowerCase()),
    );

    const cliente =
        clients.find((c) => (c._id as unknown as string) === selecionado) ??
        null;

    return (
        <div className="space-y-6">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
                <div className="lg:col-span-4">
                    <ClientesSidebar
                        filtrados={filtrados}
                        busca={busca}
                        onBuscaChange={setBusca}
                        selecionado={selecionado}
                        onSelecionar={setSelecionado}
                    />
                </div>

                <div className="lg:col-span-8">
                    {selecionado ? (
                        <ClienteForm
                            key={selecionado}
                            cliente={cliente}
                            onSave={async (data: {
                                name: string;
                                phone: string;
                                email?: string;
                                notes?: string;
                                botEnabled: boolean;
                            }) => {
                                const payload = cliente
                                    ? { _id: cliente._id, ...data }
                                    : { ...data };
                                await salvar(payload as any);
                                if (!cliente) {
                                    setSelecionado(null);
                                }
                            }}
                            onCancel={() => setSelecionado(null)}
                        />
                    ) : (
                        <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 p-8">
                            <div className="text-center">
                                <svg
                                    className="mx-auto h-12 w-12 text-gray-400 dark:text-gray-500 mb-4"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                                    />
                                </svg>
                                <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">
                                    Selecione um cliente
                                </h3>
                                <p className="text-gray-500 dark:text-gray-400">
                                    Escolha um cliente da lista ao lado para
                                    visualizar ou editar suas informações
                                </p>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
